import { FC, useRef } from "react";
import BemIt from "@gtechdoodler/bem-it";

import { AccordionContentProps } from "./AccordionContent.types";
import {
	StyledAccordionContent,
	StyledAccordionContentWrapper,
} from "./AccordionContent.styles";

const AccordionContent: FC<AccordionContentProps> = ({ children, isOpen }) => {
	const block = new BemIt("AccordionContent");

	const contentRef = useRef<HTMLDivElement>(null);
	const contentHeight = contentRef.current?.offsetHeight || 0;

	return (
		<StyledAccordionContent
			className={block.out}
			isOpen={isOpen}
			contentHeight={contentHeight}
		>
			<StyledAccordionContentWrapper ref={contentRef}>
				{children}
			</StyledAccordionContentWrapper>
		</StyledAccordionContent>
	);
};

export default AccordionContent;
